<div class="dropdown-wrapper">
    <ham-button
        #reportTypeFilterButtonWrapper
        class="status-filter-button"
        size="lg"
        [variant]="selectedReportType?.length && isFilterActive ? 'transparent' : 'white'"
        [outline]="true"
        rightIcon="assets/hamIcons/chevron-down.svg"
        (click)="openFlyout(reportTypeFilterButtonWrapper)"
    >
        <span class="filter-number" *ngIf="selectedReportType?.length && isFilterActive">
            {{ selectedReportType?.length }}
        </span>
        {{ 'aumico_po_report_type_filter_label' | i18next }}
    </ham-button>
</div>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-content">
        <div
            *ngFor="let reportType of reportTypeOptions"
            class="custom-checkbox status-option"
            (click)="toggleStatusSelection(reportType.value)"
            [class.selected]="selectedReportType?.includes(reportType.value)"
        >
            <input
                type="checkbox"
                [checked]="selectedReportType?.includes(reportType.value)"
                (change)="$event.stopPropagation()"
            />
            <label (click)="$event.stopPropagation(); toggleStatusSelection(reportType.value)"> {{ reportType.label }}</label>
        </div>
        <div class="filter-actions">
            <ham-button variant="teal" size="sm" (click)="applyFilter()">{{
                'aumico_pm_tasks_apply_filter' | i18next
            }}</ham-button>
            <ham-button variant="white" size="sm" (click)="clearFilter()">{{
                'aumico_pm_tasks_filter_clear' | i18next
            }}</ham-button>
        </div>
    </div>
</span>
